/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState, useMemo } from "react";
import { Route, Redirect } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useTheme } from '@material-ui/core/styles';
import MasterPage from "../components/masterPage/masterPage.component.js";
import CustomAlert from '../../src/components/CustomAlert.jsx'; 
import WarningIcon from "../components/IconsLibrary/WarningIcon.jsx";
import Loading from "../components/Loading.jsx";
import { validateTokenAction, tokenValidation } from "../actions/auth.action.entry";
import { useHistory } from 'react-router'
import * as signalR from '@microsoft/signalr';
import { API_SECURITY_ENDPOINT, API_SOCKET_ENDPOINT } from "../config/config.entry";
/**
 * PrivateRoute function (Intercepts all private routes with token verification service consumption,
 * on success and valid response, return a React Fragment with component and sidenav,
 * on fail, return a login redirect, on loading return a centered spinner)
 *
 * @export function
 * @param {Component} PrivateRoute
 * @param {String} roleNames
 * @param {String} location
 * @returns React.Fragment, Redirect 
 */

const getMulishText = (fontWeight, color, fontSize) => ({
  fontFamily: 'Mulish, sans-serif',
  fontSize,
  fontWeight,
  color,
});
const messageStyle = (
  theme,
  firstImageIcon,
  marginTopImage,
  minWidth,
  minHeight,
  paddingBottom = 16,
) => ({
  firstImage: firstImageIcon,
  styleMessage: {
    ...getMulishText(700, '#575756', '18px'),
    paddingBottom,
    paddingLeft: '8px',
    paddingRight: '8px',
    paddingTop: '1px',
  },
  firstImageStyles: {
    display: 'block',
    margin: 'auto',
    marginTop: marginTopImage,
  },
  '& .makeStyles-root-1433': {
    display: 'none',
  },
  styleTitle: {
    display: 'none',
  },
  dialogStyle: { minWidth, minHeight },
  styleButtonAcept: { minWidth: '30%' },
});

const PrivateRoute = ({ component: Component, isAuth, ...rest }, props) => {
  const [connectionId, setConnectionId] = useState('');
  const [isConnected, setIsConnected] = useState(false);
  const [isValidated, setIsValidated] = useState(false);
  const [isCloseSession, setIsCloseSession] = useState(false);
  const [hasRedirected, setHasRedirected] = useState(false);
  const [alertInfo, setAlertInfo] = useState({});
  const [isSessionValidating, setIsSessionValidating] = useState(false);
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const dialogColorIcon = theme?.iconColorError?.buttonCard?.backgroundColor;
  const OwnWarningIcon = useMemo(() => (
    <WarningIcon color={dialogColorIcon} />
  ), [dialogColorIcon]);
  const dispatch = useDispatch();
  const history = useHistory();
  // eslint-disable-next-line no-unused-vars
  const [_, setOpen] = useState(false);
  const handleAcceptButton = () => {
    setIsCloseSession(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = '/';
  };
  const handleAlert = (information) => {
    setAlertInfo({
      textButtonAcept: 'Aceptar',
      handleAccept: handleAcceptButton,
      messageAlert: messageStyle(theme, OwnWarningIcon, 40, '408px', '200px'),
      showClose: false,
      isOnlyMessage: false,
      mensajeModal: information,
    });
  };
  useEffect(() => {
    const jwtToken = sessionStorage.getItem("jwtToken");
    // const appName = rest.appName;
    const paramToken = window.location.search.substring(1);

    if (!paramToken && !jwtToken) {
      return <Redirect to='/login' />
    }
    if (paramToken && !jwtToken) {
      dispatch(validateTokenAction(paramToken));
      history.replace({
        search: "",
      })

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const protocol = new signalR.JsonHubProtocol();
    const transport = signalR.HttpTransportType.WebSockets;

    const options = {
        transport,
        skipNegotiation: true,
        logMessageContent: true,
    };

    const connection = new signalR.HubConnectionBuilder()
        .withUrl(`${API_SOCKET_ENDPOINT}/api/connections/session`, options)
        .withHubProtocol(protocol)
        .withAutomaticReconnect()
        .build();

        connection.start()
        .then(() => {
            setConnectionId(connection.connectionId);
            setIsConnected(true);

            connection.invoke("GetConnectionId").then(connectionId => {
                setConnectionId(connectionId);
            });

            connection.on('ReceiveSessionStatus', message => {
                if (hasRedirected) {
                connection.stop().then(() => {
                setIsCloseSession(false);
                window.location.href = '/';;
                localStorage.clear();
                sessionStorage.clear();
              }).catch((err) => {
                console.error('Error closing connection', err);
              });
            } else {
              setIsCloseSession(true);
              connection.stop().then(() => {
                handleAlert(message.message);
                console.log('Cierra la conexión del websocket');
              }).catch((err) => {
                console.error('Error closing connection', err);
              });
            }
            });
        })
        .catch(e => console.log('Connection failed: ', e));
  }, [hasRedirected]);

  useEffect(() => {
    if (connectionId && isConnected && !isValidated) {
      const token = sessionStorage.getItem("jwtToken");
      const validateSession = async () => {
        setIsSessionValidating(true);
        try {
            const response = await fetch(`${API_SECURITY_ENDPOINT}/api/user/validatesession`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': token,
              'connectionId': connectionId,
            }
          });
          setIsValidated(true);
          if (response.status===401){
            setHasRedirected(true);
            setIsCloseSession(false);
            setIsSessionValidating(false);
            setLoading(false);
            window.location.href = '/';
            localStorage.clear();
            sessionStorage.clear();
          }
        } catch (e) {
          console.error('Error al validar la sesión:', e);
        } finally {
          setIsSessionValidating(false);
        }
      };
      validateSession();
    }
  }, [connectionId, isConnected, isValidated, hasRedirected]);

  return (
    <>
      {loading ? (
        <Loading />
      ):(
        <Route
          {...rest}
          render={(componentProps) => (
            <Fragment>
              <MasterPage component={Component} {...componentProps} appName={rest.appName} />
            </Fragment>
          )
          }
        />
      )}
      
      {isSessionValidating ? (
        <Loading />
      ):(
        isCloseSession && (
          <CustomAlert
            isOpen={isCloseSession}
            textButtonAcept={alertInfo?.textButtonAcept}
            mensajeModal={alertInfo?.mensajeModal}
            handleAccept={alertInfo?.handleAccept}
            onCancel={alertInfo?.onCancel}
            onClose={alertInfo?.onClose}
            messageAlert={alertInfo?.messageAlert}
            showClose={alertInfo?.showClose}
            isOnlyMessage={alertInfo?.isOnlyMessage}
          />
        )
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, { validateTokenAction, tokenValidation })(PrivateRoute);
